import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import './index.scss';
import App from './App';

Sentry.init({
  dsn: "https://dcf9e185093e40c89d766c47c86dc148@o344054.ingest.sentry.io/5456203",
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
